//~ Define your application's paths as constants here
export const RootPath = '/';
export const LoginPagePath = '/login';
export const AccountsSelectionPagePath = '/accounts';
export const ProductionsSelectionPagePath = '/productions';
export const HomePagePath = RootPath;
export const AdvancedSearchPagePath = '/advanced-search';
export const DetailsPath = '/details';

export const AssetDetailsPagePath = `${DetailsPath}/asset/:assetId`;
export const createAssetDetailsPagePath = (assetId: string) =>
    AssetDetailsPagePath.replace(':assetId', assetId);

export const CollectionDetailsPagePath = `${DetailsPath}/collection/:collectionId`;
export const createCollectionDetailsPagePath = (collectionId: string) =>
    CollectionDetailsPagePath.replace(':collectionId', collectionId);

export const ExtendedCollectionsPagePath = '/collections/:title';
export const createExtendedCollectionsPagePath = (title: string) =>
    ExtendedCollectionsPagePath.replace(':title', title);

export const OperationsPagePath = '/operations';
export const NotFoundPagePath = '*';
